export type ChinaAiModel = "deepseek" | "kimi" | "qwen" | "doubao";

export const CHINA_AI_MODEL_OPTIONS: ReadonlyArray<{ value: ChinaAiModel; label: string }> = [
  { value: "deepseek", label: "DeepSeek" },
  { value: "kimi", label: "Kimi" },
  { value: "qwen", label: "千问" },
  { value: "doubao", label: "豆包" },
];

export function normalizeChinaAiModel(value: unknown): ChinaAiModel {
  return CHINA_AI_MODEL_OPTIONS.some((option) => option.value === value)
    ? value as ChinaAiModel
    : "deepseek";
}

export function chinaAiModelName(value: ChinaAiModel): string {
  return CHINA_AI_MODEL_OPTIONS.find((option) => option.value === value)?.label || "DeepSeek";
}
